module.exports = __webpack_public_path__ + "media/megamenu/Photokive-e7fd4577.jpg";